// extracted by mini-css-extract-plugin
module.exports = {"heading":"ModalHeadings_heading__2JogX","subHeading":"ModalHeadings_subHeading__18Ioq"};